<template>
	<dashboard-dropdown-section
		title="Offers Near Me"
		type="locum-offers-near-me"
		:items-shown="5"
		:items="offers"
		event-name="load-locum-offers-near-me"
		@load-locum-offers-near-me="loadMore"
	/>
</template>

<script>
import { mapActions } from 'vuex';
import { bus } from '@/main';
import moment from 'moment';

import store from '@/store';
import DashboardDropdownSection from '@/components/custom/DashboardDropdownSection';

export default {
	name: 'LocumApplicationsSent',

	components: { DashboardDropdownSection },

	data: () => ({
		offers: [],
		locumAvailableDates: [],
	}),

	computed: {
		locumIsApproved() {
			return store.getters.user.approved;
		},
	},

	mounted() {
		bus.$on('view-offer-near-me', offer => {
			this.locumViewOffer(offer);
		});
	},

	methods: {
		...mapActions('offers', ['FetchOffers']),

		...mapActions('availability', ['LoadAvailabilityByProfessional']),

		...mapActions('bookings', ['LoadProfessionalBookings']),

		async loadMore(event) {
			const { startDate, endDate } = event;

			const offersRequests = await this.FetchOffers({ startDate, endDate, offersType: 'locum-offers-near-me' });
			const filteredOffersRequests = offersRequests.map(offer => ({ ...offer, event_start_date: offer.date }));

			const locumAvailableDates = await this.getAvailableDates(store.getters.user, startDate, endDate);

			this.locumAvailableDates = locumAvailableDates;

			const offers = filteredOffersRequests.filter(request => {
				const someDatesAvailable = request.available_dates.some(available_date =>
					locumAvailableDates.find(dateInfo => dateInfo.date === available_date && dateInfo.status !== 'Unavailable')
				);
				return someDatesAvailable;
			});

			this.offers = offers;
		},

		getDates(date, end_date) {
			let dates = [];
			let count = moment(end_date).diff(date, 'days');
			for (let iteration = 0; iteration <= count; iteration++) {
				let futureDate = moment(date).add(iteration, 'days').format('YYYY-MM-DD');
				dates.push(futureDate);
			}
			return dates.sort((a, b) => moment(a).diff(moment(b)));
		},

		async getAvailableDates(locum, startDate, endDate) {
			const search_dates = this.getDates(startDate, endDate);
			const avails = await this.LoadAvailabilityByProfessional({
				professionalId: locum.id,
				start_date: startDate,
				end_date: endDate,
			});

			const bookings = await this.LoadProfessionalBookings({
				accountId: locum.id,
				startDate: startDate,
				endDate: endDate,
			});

			const allEvents = avails.concat(bookings);

			const datesArray = search_dates.reduce((datesArr, date) => {
				datesArr.push({ date, already_booked: false, status: 'Possibly Available' });
				return datesArr;
			}, []);

			const mappedDates = datesArray.map(availDate => {
				const matchingEvents = allEvents.filter(({ available_dates, booking_dates }) => {
					const datesArr = available_dates ? available_dates : booking_dates;
					if (!datesArr) {
						return false;
					}
					return datesArr.includes(availDate.date);
				});

				if (matchingEvents.length === 0) {
					return availDate;
				}

				let dateStatus = 'Possibly Available';
				let availability = { start_time: '', end_time: '' };
				let isBooked = false;

				for (const { status, start_time, end_time } of matchingEvents) {
					const { status: existingStatus } = availDate;

					if (status === 'confirmed') {
						dateStatus = 'Unavailable';
						isBooked = true;
					}
					if (status === 'unavailable' && existingStatus !== 'Unavailable') {
						dateStatus = 'Unavailable';
					}
					if ((status === 'open' || status === 'requested') && existingStatus !== 'Unavailable') {
						dateStatus = 'Available';
						availability = {
							start_time,
							end_time,
						};
					}
					if (status === 'partially-confirmed' && existingStatus !== 'Unavailable') {
						dateStatus = 'Unavailable';
					}
				}

				availDate.status = dateStatus;
				availDate.already_booked = isBooked;
				if (availability.start_time && availability.end_time) {
					availability.id = locum.id;
					availability.date = startDate;
					availDate.availability = availability;
				}

				return availDate;
			});

			return mappedDates;
		},

		showLocumUnapprovedBanner() {
			window.scrollTo(0, 0);
			bus.$emit('locum-not-approved', 'You cannot apply to Practice Offers until your profile has been approved ');
		},

		async locumViewOffer(offer) {
			if (this.locumIsApproved) {
				const { available_dates, company, start_time, end_time, lunch, notes, profession, rates, experience, id: offerId, request_dates, skills } = offer;

				const matchingDates = this.locumAvailableDates.filter(({ date }) => available_dates.includes(date));

				const booking = {
					start_time,
					end_time,
					booking_dates: available_dates,
					lunch,
					notes,
					profession,
					rates,
					experience,
					id: offerId,
					mapped_dates: matchingDates,
					request_dates: request_dates ?? null,
					skills,
				};
				store.dispatch('setLocumViewingPractice', { id: company.id, booking, source: 'viewOffersNearMe' });
				bus.$emit('change-context', 'view-practice-details-card');
			} else {
				this.showLocumUnapprovedBanner();
			}
		},
	},
};
</script>
